import { FC } from "react";
import PROFILE_PIC from "@/assets/images/Avatar-3x.png";

interface BodyImageWithInfoColumnPropTypes {
  width?: any;
  imgSrc: any;
  roundedImg?: string;
  textName?: string;
  textDesc?: string;
  onClick?: () => void;
  defaultImg?: string
}

const BodyImageWithInfoColumn: FC<BodyImageWithInfoColumnPropTypes> = ({
  width,
  imgSrc,
  roundedImg,
  textName,
  textDesc,
  onClick,
  defaultImg
}) => {
  const handleImageError = (event:any) => {
    event.target.src = defaultImg || PROFILE_PIC
  }
  return (
    <td width={width}>
      <div className="flex-body-column">
        <img
          src={imgSrc}
          alt="body-product-img"
          onError={handleImageError}
          style={{ borderRadius: roundedImg ? roundedImg : "unset" }}
        />

        <div className="info-content">
          {textName && (
            <span
              className="column-name"
              style={{
                maxWidth: width ? `calc(${width} - 60px)` : "unset",
                cursor: onClick ? "pointer" : "",
              }}
              title={textName}
              onClick={() => (onClick ? onClick() : () => {})}
            >
              {textName}
            </span>
          )}

          {textDesc && (
            <span
              className="column-desc"
              style={{ maxWidth: width ? `calc(${width} - 60px)` : "unset" }}
              title={textDesc}
            >
              {textDesc}
            </span>
          )}
        </div>
      </div>
    </td>
  );
};

export default BodyImageWithInfoColumn;
